<template>
  <div class="payment-container">
    <h4 class="header">{{ this.$route.params.title }}</h4>
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-company-list' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Companies</p>
      </div>
      <!-- <div class="primary-button">
        <primary-button
          @click.native="
            $router.push({ name: 'system-admin-add-manual-payment' })
          "
          >Add Payment</primary-button
        >
      </div> -->
    </nav>
    <div
      class="table_div"
      style="width: 100%; overflow-x: auto; overflow-y: hidden"
    >
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header">
            <th class="time">Date</th>
            <!-- <th>Company</th> -->
            <th>Created By</th>
            <th class="time">
              Created On
              <span @click="sorting('up', 'created_on')" class="sorting"
                >&#8593;</span
              >
              <span @click="sorting('down', 'created_on')" class="sorting"
                >&#8595;</span
              >
            </th>
            <th>Amount</th>
            <th>Method</th>
            <th>Transaction ID</th>
            <!-- <th class="description">Description</th> -->
          </tr>
        </thead>
        <tbody>
          <tr class="line" v-for="(payment, k) in payments" :key="k">
            <th class="time">{{ payment.date }}</th>
            <!-- <th>
              <img class="popup_image" src="@/assets/person.jpg" alt />
              {{ payment.companyName }}
            </th> -->
            <th>{{ payment.createdBy }}</th>
            <th class="time">{{ payment.date }}</th>
            <th class="Invoice_price">${{ payment.amount }}</th>
            <th class="method">{{ payment.method }}</th>
            <th></th>
            <!-- <th class="description"></th> -->
          </tr>
        </tbody>
      </table>
    </div>
    <div class="per-page">
      <span class="filter_by custom-row">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item, key) in pages" :key="key">
            {{ item }}
          </option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="payments.length"
      />
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
  },
  data: () => ({
    showDropDown: false,
    payments: [],
    per_page: 10,
    pages: [10, 50, 100],
    TotalPages: null,
    Searched: "",
    Page: 0,
  }),
  created() {
    this.SetTitle();
    this.GetList();
  },

  methods: {
    changePerPage() {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    SetTitle() {
      const company_name = this.$route.params.title;
      const page_title = `${company_name} Payment History`;
      this.$store.commit("setPageHeader", page_title);
    },
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.GetList(order_dir, sortBy);
    },
    GetList(order_dir, order_by) {
      this.$store
        .dispatch("GetPaymentList", {
          search: this.Searched,
          page: this.Page,
          company_uuid: this.$route.params.id,
          per_page: this.per_page,
          order_dir: order_dir || "asc",
          order_by: order_by || "created_on",
        })
        .then((res) => {
          console.log("res--->", res);
          this.payments = res.items.map(this.transformPayments);
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformPayments(i, k) {
      return {
        invoiceId: i.invoice_uuid,
        invoiceNumber: i.invoice_number,
        method: i.method,
        createdBy: i.created_by,
        companyName: i.company_name,
        date: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        amount: i.amount,
      };
    },
    outside() {
      this.showDropDown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-container {
  width: 100%;
  padding: 0 20px;

  .header {
    //padding: 20px 20px;
    font-size: 16px;
    // font-weight: 800;
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    width: 100% !important;
    align-items: center;
    height: 40px;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th {
    text-align: center;

    &.time {
      width: 210px;

      .sorting {
        cursor: pointer;
      }
    }
  }
  tbody th {
    padding-left: 0;
    padding-right: 0;
  }
  .description {
    width: 400px;
  }
  .method {
    text-transform: capitalize;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3, #51b5f3);
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  float: right;
  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}
.Invoice_table_header th {
  color: #fff;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  vertical-align: middle;
}
table thead th:first-child {
  padding-left: 35px;
}
table th:first-child {
  padding-left: 35px;
}

tbody th.company_inc {
  width: 110px;
  color: #55616e;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 0 12px 0;
}
.Invoice_price {
  font-family: "Helvetica Neue";
  padding: 12px 0 12px 0;
  color: #000000;
  line-height: 20px;
}
.Invoice_table_header th.Invoice_header_total {
  padding-left: 40px;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.status:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 20px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 0 0 0 12px;
}
@media (max-width: 1550px) {
  table.Invoice_table {
    width: 1440px;
  }
}

.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

